"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const ReactDOM = require("react-dom");
const ErrorHandlerComponent_1 = require("../ErrorHandler/ErrorHandlerComponent");
const dialog_1 = require("./dialog");
const types_1 = require("./types");
const RenderModal = (component, selector, title, additionalParameters, popupType = types_1.PopupType.FORM) => {
    const { classes, backdrop, keyboard, onModalClose, popupAriaLabel, closeButtonAriaLabel } = additionalParameters;
    ReactDOM.render((0, jsx_runtime_1.jsx)(ErrorHandlerComponent_1.ErrorHandlerComponent, { children: (0, jsx_runtime_1.jsx)(dialog_1.Dialog, { title: title, classes: classes, isOpen: true, backdrop: backdrop, keyboard: keyboard, onClose: onModalClose, popupAriaLabel: popupAriaLabel, closeButtonAriaLabel: closeButtonAriaLabel, reactDOMRenderId: app_1.DateService.getTimestamp(), popupType: popupType, children: component }) }), selector);
};
exports.RenderModal = RenderModal;
